import { render, staticRenderFns } from "./ApplicationsTable.vue?vue&type=template&id=ee35769a&lang=pug"
import script from "./ApplicationsTable.vue?vue&type=script&lang=ts"
export * from "./ApplicationsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ApplicationsTable.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FCompliance%2FTeammates%2FRemove%2FApplicationsTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports